export default function usePageTitle(title: string) {
    document.title = `BANCOS - ${title}`;
}